<div class="search-holder">
  <form [formGroup]="searchForm" class="example-form">
    <mat-form-field class="example-full-width" style="float: right; margin-top: 10px" appearance="outline">
      <mat-label>Search</mat-label>
      <input type="search" matInput formControlName="searchCtrl" #message maxlength="50" placeholder="Search" />
    </mat-form-field>
  </form>
</div>

<table class="table">
  <thead>
    <tr>
      <th width="{{ isType === 'Division' ? widthIndex - 20 : widthIndex }}%">
        #
      </th>
      <th width="{{ widthName }}%">Name</th>
      <th width="{{ widthName }}%">Id</th>
      @if (isType === 'Division') {
        <th style="text-align: left" width="30%">
          Company Name
        </th>
      }
      @if (isType === 'Music') {
        <th width="30%">Play Music</th>
      }
      @if (isType === 'Voice') {
        <th width="30%">Play Voice</th>
      }
      @if (isType === 'Video') {
        <th width="30%">Preview Video</th>
      }
      @if (isType === 'Pdf') {
        <th width="30%">Preview Pdf</th>
      }

      <th>Actions</th>
    </tr>
  </thead>
  <tbody>
    @if (items && items.length <= 0) {
      <tr>
        <td></td>
        <td>NO DATA FOUND</td>
      </tr>
    }
    @for (item of items; track item; let i = $index) {
      <tr>
        <td>
          <strong>{{ i + 1 }}</strong>
        </td>
        <td>
          <strong>{{ item?.name || item?.character || item?.company_name
          }}</strong>
        </td>
        <td>
          <strong>{{ item?._id }}</strong>
        </td>
        @if (isType === 'Division') {
          <td style="text-align: left">
            <strong>{{ item?.companyId?.name }}</strong>
          </td>
        }
        @if (isType === 'Music' || isType === 'Voices') {
          <td>
            <audio controls preload="none">
              <source src="{{ item.url }}" type="audio/mp3" />
              Your browser does not support the audio tag.
            </audio>
          </td>
        }
        @if (isType === 'Video') {
          <td style="min-width: 200px">
            <span class="material-icons" style="font-size: 50px; cursor: pointer"
              (click)="playVideo(playVideoModal, item.url)">
              play_circle_filled
            </span>
          </td>
        }
        @if (isType === 'Pdf') {
          <td style="min-width: 200px">
            <span class="material-icons" style="font-size: 50px; cursor: pointer"
              (click)="previewPdf(previewPdfModal, item.url)">
              preview
            </span>
          </td>
        }
        <td nowrap>
          @if (showButtons.indexOf('edit') > -1) {
            <button type="button" class="btn btn-raised btn-success btn-sm btn-action mlr-2"
              (click)="ecModal(editModal, i, 'e', item)">
              <span class="fa fa-edit"></span> edit
            </button>
          }
          @if (showButtons.indexOf('clone') > -1) {
            <button [disabled]="isType === 'Voices'" type="button"
              class="btn btn-raised btn-warning btn-sm btn-action mlr-2" (click)="ecModal(cloneModal, i, 'c', item)"
              >
              <span class="fa fa-clone"></span> clone
            </button>
          }
          @if (showButtons.indexOf('delete') > -1 && isNotCurrentUser(item)) {
            <button type="button" class="btn btn-raised btn-danger btn-sm btn-action mlr-2"
              (click)="ecModal(deleteModal, i, 'd', item)"
              >
              <span class="fa fa-trash"></span> Remove
            </button>
          }
          @if (showButtons.indexOf('players') > -1 && isNotCurrentUser(item)) {
            <button type="button" class="btn btn-raised btn-secondary btn-sm btn-action mlr-2" (click)="clickPlayersBtn(item)"
              >
              <span class="ft-users"></span> Players
            </button>
          }
          @if (reportBtn) {
            <button type="button" class="btn btn-raised btn-success btn-sm btn-action mlr-2" (click)="downloadReport(item)"
              >
              <span class="fa fa-download"></span> report
            </button>
          }
        </td>
      </tr>
    }
  </tbody>
</table>
<div class="justify-content-center" style="overflow: scroll;">
  <ngb-pagination [(collectionSize)]="maxCount" [(page)]="currentPage" maxSize="50" pageSize="50"
    (pageChange)="loadPage($event)" boundaryLinks="true" maxSize="10" rotate="true">
  </ngb-pagination>
</div>

<!-- Modal for Edit -->
<ng-template #editModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Edit {{ isType }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="onUploadDialogClose('close')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="form">
      <div class="row m-tb-15">
        <div class="col-6">
          <mat-form-field class="full-width">
            <mat-label>{{ isType }} Name</mat-label>
            <input matInput placeholder="Name" formControlName="name" />
          </mat-form-field>
        </div>
        @if (isType === 'File' || isType === 'Video') {
          <div class="col-6">
            @if (isType === 'File' || isType === 'Video') {
              <mat-form-field class="full-width">
                <mat-label>{{ isType }} Url</mat-label>
                <input matInput placeholder="Enter {{ isType }} URL" formControlName="url" />
              </mat-form-field>
            }
          </div>
        }
      </div>
    </form>
    <div class="row m-tb-15">
      <div class="col-12">
        @if (isType === 'File') {
          <app-s3-file-upload (fileUploadedEvent)="fileUploaded($event)"></app-s3-file-upload>
        }
      </div>
    </div>

    @if (
      previewURL &&
      previewURL !== '' &&
      isType !== 'Music' &&
      isType !== 'Pdf' &&
      isType !== 'Voices' &&
      isType !== 'File'
      ) {
      <div class="imagePreview justify-content-center">
        <img [src]="previewURL" alt="No Image Found" />
      </div>
    }

    @if (
      previewURL &&
      previewURL !== '' &&
      (isType === 'Music' || isType === 'Voices')
      ) {
      <div class="imagePreview">
        <audio class="audioCenter" controls>
          <source src="{{ previewURL }}" type="audio/mp3" />
          Your browser does not support the audio tag.
        </audio>
      </div>
    }
    @if (isType !== 'Video' && isType !== 'File') {
      <app-upload [isUploading]="uploading" (filetoUpload)="uploadItem($event)"
        >
      </app-upload>
    }
  </div>

  <div class="modal-footer">
    <button type="button" [disabled]="form.invalid" class="btn btn-raised btn-success"
      (click)="c('Close click'); editItem()">
      Edit {{ isType }}
    </button>

    <button type="button" class="btn btn-secondary btn-raised" (click)="onUploadDialogClose('dismiss')">
      Close
    </button>
  </div>
</ng-template>

<!-- modal for clone -->
<ng-template #cloneModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Clone {{ isType }}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="form">
      <div class="row m-tb-15">
        <div class="col-6">
          <mat-form-field class="full-width">
            <mat-label>{{ isType }} Name</mat-label>
            <input matInput placeholder="Name" formControlName="name" />
          </mat-form-field>
        </div>
        @if (isType === 'File' || isType === 'Video') {
          <div class="col-6">
            <mat-form-field class="full-width">
              <mat-label>{{ isType }} Url</mat-label>
              <input matInput placeholder="Enter {{ isType }} URL" formControlName="url" />
            </mat-form-field>
          </div>
        }
      </div>

      @if (
        previewURL &&
        previewURL !== '' &&
        isType !== 'Music' &&
        isType !== 'Voices' &&
        isType !== 'File'
        ) {
        <div class="imagePreview justify-content-center">
          <img [src]="previewURL" alt="No Image Found" />
        </div>
      }
      @if (
        previewURL &&
        previewURL !== '' &&
        (isType === 'Music' || isType === 'Voices')
        ) {
        <div class="imagePreview">
          <audio class="audioCenter" controls>
            <source src="{{ previewURL }}" type="audio/mp3" />
            Your browser does not support the audio tag.
          </audio>
        </div>
      }
    </form>
    <div class="row m-tb-15">
      <div class="col-12">
        @if (isType === 'File') {
          <app-s3-file-upload (fileUploadedEvent)="fileUploaded($event)"></app-s3-file-upload>
        }
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" [disabled]="form.invalid" class="btn btn-raised btn-success"
      (click)="c('Close click'); cloneItem()">
      Clone {{ isType }}
    </button>

    <button type="button" class="btn btn-secondary btn-raised" (click)="c('Close click')">
      Close
    </button>
  </div>
</ng-template>

<!-- delete MOdal -->
<ng-template #deleteModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Delete {{ isType }}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">Confirm Delete <b>{{form.controls.name.getRawValue()}}</b></div>
  <div class="modal-footer">
    <button type="button" class="btn btn-raised btn-danger" (click)="c('Close click'); deleteItem()">
      Delete {{ isType }}
    </button>

    <button type="button" class="btn btn-secondary btn-raised" (click)="c('Close click')">
      Close
    </button>
  </div>
</ng-template>

<ng-template #playVideoModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Preview {{ isType }} {{ videoTitle }}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
    <div id="videoContainer" style="text-align: center"></div>
  </div>
</ng-template>

<ng-template #previewPdfModal let-c="close" let-d="dismiss" let-url="pdfUrl">
  <div class="modal-header">
    <div class="preview-buttons">
      <h4 class="modal-title">Preview {{ isType }}</h4>
      <a class="material-icons" href="{{previewURL}}" target="_blank">download</a>
    </div>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click'); closeVideoModal()">
    </button>
  </div>
  @if (loadingPdf) {
    <mat-spinner style="margin-left: 40%; margin-top: 11%"></mat-spinner>
  }
  <div class="modal-body">
    <pdf-viewer [src]="previewURL" (after-load-complete)="pdfLoadedStopSpinner()" [render-text]="true"
    style="display: block; height: 100vh"></pdf-viewer>
  </div>
</ng-template>